/* ============================================================
   KICK DOCK — assets/ks-dock.js
   Loaded (defer) by sections/ks-dock.liquid only while the dock is on.

   Reads #ks-dock-config (written by Liquid), the saved sizes and the fit
   maths from window.KSFinder (snippets/ks-finder-core), the delivery
   estimate from window.KSDelivery (assets/ks-delivery.js) and the bag
   from /cart.js. Add to cart presses the theme's own button, so stock,
   errors and the cart drawer behave exactly as without the dock.

   States: unknown → fit → product → purchase. Every visible text comes
   from the config and is set with textContent (never innerHTML).
   ============================================================ */
(function () {
  'use strict';
  if (window.__ksDockLoaded) return;
  window.__ksDockLoaded = true;

  var cfgEl = document.getElementById('ks-dock-config');
  var dock = document.getElementById('KsDock');
  if (!cfgEl || !dock) return;
  /* Out of the footer section and straight under <body>: the theme editor
     scrolls to a section when you click inside it, and the footer is at
     the very bottom of the page. Under <body> a tap on the dock is just a
     tap on the dock. */
  var ownSection = dock.closest('.shopify-section');
  document.body.appendChild(dock);
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target;
      if (!sec || !sec.querySelector || !sec.querySelector('#ks-dock-config')) return;
      /* the editor re-rendered this section: start again with the new settings */
      var old = document.getElementById('KsDock');
      if (old && old !== sec.querySelector('#KsDock')) old.parentNode.removeChild(old);
      var olddiag = document.querySelector('[data-kd-diag]');
      if (olddiag && !sec.contains(olddiag)) olddiag.parentNode.removeChild(olddiag);
      window.__ksDockLoaded = false;
      var src = document.querySelector('script[src*="ks-dock.js"]');
      var fresh = document.createElement('script');
      /* keep the ?v= part: the bare asset URL can come back stale from the CDN */
      fresh.src = (src ? src.src : '') + (src && src.src.indexOf('?') > -1 ? '&' : '?') + 'r=' + Date.now();
      document.body.appendChild(fresh);
    }, { once: true });
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target === ownSection) { var d = document.getElementById('KsDock'); if (d) d.parentNode.removeChild(d); }
    }, { once: true });
  }
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var T = cfg.t || {};
  var isPhone = window.matchMedia('(max-width: 767px)');

  /* ---------- small helpers ---------- */
  function $(sel, root) { return (root || dock).querySelector(sel); }
  function txt(k, d) { var v = T[k]; return v == null || v === '' ? (d || '') : String(v); }
  function usOf(v) { return parseFloat(String(v).replace(/[^0-9.]/g, '')); }
  function trim(n) { return (Math.round(n * 10) / 10).toString(); }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function clear(node) { while (node.firstChild) node.removeChild(node.firstChild); }
  function reduced() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  /* money: shop.money_format with the amount in cents */
  function money(cents) {
    var f = cfg.money || '${{amount}}';
    var n = (cents || 0) / 100;
    function fmt(dec, thou, pt) {
      var s = n.toFixed(dec);
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.length > 1 ? parts[0] + pt + parts[1] : parts[0];
    }
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(f);
    var key = m ? m[1] : 'amount', out;
    switch (key) {
      case 'amount_no_decimals': out = fmt(0, ',', '.'); break;
      case 'amount_with_comma_separator': out = fmt(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = fmt(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = fmt(2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': out = fmt(0, ' ', '.'); break;
      case 'amount_with_space_separator': out = fmt(2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': out = fmt(2, ' ', '.'); break;
      default: out = fmt(2, ',', '.');
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]*>/g, '').trim();
  }
  /* the currency app converts .money spans that are already on the page */
  function refreshMoney() {
    if (window.baCurr && typeof window.baCurr.refreshConversion === 'function') {
      try { window.baCurr.refreshConversion(); } catch (e) {}
    }
  }
  /* Fill a template into `node`: text pieces as text nodes, [price] as
     <span class="money"> so the currency app can convert it. */
  function fill(node, tpl, vars) {
    clear(node);
    var re = /\[(\w+)\]/g, last = 0, m;
    while ((m = re.exec(tpl))) {
      if (m.index > last) node.appendChild(document.createTextNode(tpl.slice(last, m.index)));
      var k = m[1];
      if (k === 'price' && vars.priceCents != null) {
        var s = el('span', 'money', money(vars.priceCents));
        node.appendChild(s);
      } else {
        node.appendChild(document.createTextNode(vars[k] == null ? '' : String(vars[k])));
      }
      last = re.lastIndex;
    }
    if (last < tpl.length) node.appendChild(document.createTextNode(tpl.slice(last)));
    if (window.baCurr && typeof window.baCurr.refreshConversion === 'function') {
      try { window.baCurr.refreshConversion(); } catch (e) {}
    }
  }

  /* ---------- nodes ---------- */
  var bar = $('[data-kd-bar]'), panel = $('[data-kd-panel]');
  var mainBtn = $('[data-kd-main]'), kEl = $('[data-kd-k]'), subEl = $('[data-kd-sub]');
  var chip = $('[data-kd-chip]'), cta = $('[data-kd-cta]'), ctaText = $('[data-kd-cta-text]');
  var chatBtn = $('[data-kd-chat]'), chatDot = $('[data-kd-chat-dot]');
  var diag = document.querySelector('[data-kd-diag]');

  /* ---------- sizes (KSFinder) ---------- */
  var KS = window.KSFinder || null;
  var SV = KS && KS.sizes && KS.sizes.on && cfg.sizesOn ? KS.sizes : null;

  function people() { return SV ? SV.list() : []; }
  function person() {
    var list = people();
    if (!list.length) return null;
    var id = SV.pick();
    var p = id ? SV.get(id) : null;
    if (p) return p;
    var last = KS.recall ? KS.recall() || {} : {};
    if (!(last.foot >= 10) && list.length === 1) return list[0];
    /* several people, nobody picked: the one measured most recently */
    return list.slice().sort(function (a, b) { return (+b.t || 0) - (+a.t || 0); })[0];
  }
  function recFor(model, p) {
    if (!model || !p || !KS) return null;
    var r = KS.sizeFor(model, p.foot, { fit: p.fit, socks: p.socks });
    if (!r) return { none: true };
    var pick = r.best || r.bestAny;
    return { r: r, pick: pick, soldOut: !r.best, good: pick.score >= 75 };
  }
  /* Off the product page: the size that most of the models agree on */
  function fitAcross(p) {
    if (!KS || !KS.products || !KS.products.length) return null;
    var count = {}, bestUs = null, bestN = 0;
    KS.products.forEach(function (m) {
      var x = recFor(m, p);
      if (!x || x.none) return;
      var k = String(x.pick.us);
      count[k] = (count[k] || 0) + 1;
      if (count[k] > bestN) { bestN = count[k]; bestUs = x.pick.us; }
    });
    return bestUs;
  }
  function finderUrl(p) {
    var u = cfg.urls.finder || '/pages/size-finder';
    if (!p || !(p.foot >= 10)) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'ks_foot=' + trim(p.foot) + '&ks_fit=' + encodeURIComponent(p.fit || 'comfort') + (p.socks ? '&ks_socks=1' : '');
  }

  /* Shopify cuts the spaces off text settings: " · " arrives as "·" */
  function sepTxt() {
    var s = txt('sep', ' · ');
    if (!/^\s/.test(s)) s = ' ' + s;
    if (!/\s$/.test(s)) s += ' ';
    return s;
  }
  /* "Me" reads "you"; everybody else by name */
  function isMe(p) { return !!p && /^(me|myself|my size|mine)$/i.test(String(p.name || '').trim()); }
  function who(p) { return !p ? '' : isMe(p) ? txt('you', 'you') : p.name; }
  function strFill(tpl, vars) { var t = el('span'); fill(t, tpl, vars); return t.textContent; }
  function withFoot(url, p) {
    if (!p || !(p.foot >= 10)) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'ks_foot=' + trim(p.foot) + '&ks_fit=' + encodeURIComponent(p.fit || 'comfort') + (p.socks ? '&ks_socks=1' : '');
  }

  /* ---------- the catalogue: other models, loaded only when needed ----------
     KSFinder.catalog (snippets/ks-finder-core.liquid) reads the small JSON
     list /collections/<handle>?view=ks-data once and keeps it 10 minutes;
     Shop by size and the size guide use the same copy. */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';
  var ALL_URL = 'all';
  function catNow(handle) { return KS && KS.catalogNow ? KS.catalogNow(handle) : null; }
  function loadCat(handle, done) {
    done = done || function () {};
    if (KS && KS.catalog) KS.catalog(handle, done); else done([]);
  }
  /* models in the catalogue with an IN-STOCK size for this person, best first */
  function fitsFor(cat, p, skipHandle) {
    var out = [];
    if (!p || !KS) return out;
    (cat || []).forEach(function (x) {
      if (skipHandle && x.r.h === skipHandle) return;
      var r = KS.sizeFor(x.m, p.foot, { fit: p.fit, socks: p.socks });
      if (!r || !r.best) return;
      out.push({ x: x, pick: r.best, good: r.best.score >= 75 });
    });
    out.sort(function (a, b) { return b.pick.score - a.pick.score || a.x.i - b.x.i; });
    return out;
  }
  /* how many styles are made in a size that fits (sold out included) –
     the number the size finder shows on its results */
  function madeFor(cat, p, skipHandle) {
    var n = 0;
    if (!p || !KS) return 0;
    (cat || []).forEach(function (x) {
      if (skipHandle && x.r.h === skipHandle) return;
      var r = KS.sizeFor(x.m, p.foot, { fit: p.fit, socks: p.socks });
      if (r && (r.best || r.bestAny)) n++;
    });
    return n;
  }
  /* the size most of these models come out at */
  function mostUs(list) {
    var c = {}, best = null, n = 0;
    (list || []).forEach(function (a) { var k = String(a.pick.us); c[k] = (c[k] || 0) + 1; if (c[k] > n) { n = c[k]; best = a.pick.us; } });
    return best;
  }
  /* the nearest size in a model that has no size in range */
  function closestIn(m, p) {
    if (!m || !p || !KS) return null;
    var t = (KS.fits[p.fit] || KS.fits.comfort).target, eff = p.foot + (p.socks ? (KS.sockCm || 0) : 0), best = null;
    m.rows.forEach(function (r) {
      var room = Math.round((r[1] - eff) * 10) / 10, d = Math.abs(room - t);
      if (!best || d < best.d) best = { us: r[0], eu: r[2], room: room, d: d };
    });
    return best;
  }
  function shortTitle(t) {
    var s = String(t || '').replace(/^Kick Speed\S*\s*/i, '')
      .replace(/\s*Roller\s+(Skate\s+)?Shoes/i, '')
      .replace(/\s*Shoes\s+With\s+Wheels/i, '')
      .replace(/\s+for\s+Kids/i, '')
      .replace(/\s{2,}/g, ' ').trim();
    return s || String(t || '');
  }

  /* ---------- product page ---------- */
  var P = cfg.product || null;
  var model = P && KS && typeof KS.build === 'function' ? KS.build(P.raw) : null;
  var secRoot = P ? (document.querySelector('[data-section-type="product"]') || null) : null;
  var form = secRoot ? secRoot.querySelector('form[action*="/cart/add"]') : null;
  var secId = secRoot ? (secRoot.getAttribute('data-section-id') || '') : '';
  var SIZE_KEY = P ? 'option' + P.sizePos : '', COLOR_KEY = P && P.colorPos ? 'option' + P.colorPos : '';

  function radios(key) {
    return secRoot ? Array.prototype.slice.call(secRoot.querySelectorAll('input[type=radio][data-index="' + key + '"]')) : [];
  }
  function currentOpt(key) {
    if (!key || !secRoot) return '';
    var r = radios(key).filter(function (x) { return x.checked; })[0];
    if (r) return r.value;
    var s = secRoot.querySelector('select[data-index="' + key + '"]');
    return s ? s.value : '';
  }
  function choose(key, value) {
    var r = radios(key).filter(function (x) { return x.value === value; })[0];
    if (r) {
      if (!r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      return true;
    }
    var s = secRoot && secRoot.querySelector('select[data-index="' + key + '"]');
    if (s && Array.prototype.some.call(s.options, function (o) { return o.value === value; })) {
      if (s.value !== value) { s.value = value; s.dispatchEvent(new Event('change', { bubbles: true })); }
      return true;
    }
    return false;
  }
  function sizeValue(us) {
    var s = (P && P.raw.s) || [];
    for (var i = 0; i < s.length; i++) if (usOf(s[i]) === us) return s[i];
    return String(us);
  }
  function variantFor(sizeVal, color) {
    var us = usOf(sizeVal);
    var vs = (P && P.variants) || [];
    var exact = vs.filter(function (v) { return usOf(v.s) === us && (!P.colorPos || !color || v.c === color); });
    return exact.filter(function (v) { return v.a; })[0] || exact[0] || null;
  }
  function masterVariant() {
    var inp = form && form.querySelector('[name="id"]');
    if (!inp || !inp.value) return null;
    var id = String(inp.value);
    return ((P && P.variants) || []).filter(function (v) { return String(v.id) === id; })[0] || null;
  }
  function delivery(variantId) {
    if (!cfg.delivery || !window.KSDelivery || !secId) return null;
    try { return variantId ? window.KSDelivery.get(secId, variantId) : window.KSDelivery.current(secId); } catch (e) { return null; }
  }

  /* ---------- bag (/cart.js) ---------- */
  var CART = null, cartT = 0;
  function loadCart(then) {
    fetch((cfg.urls.cart || '/cart') + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) { CART = c; paintSoon(); } if (then) then(c); })
      .catch(function () {});
  }
  function cartLater() { clearTimeout(cartT); cartT = setTimeout(function () { loadCart(); }, 350); }
  document.addEventListener('cart:updated', function (e) {
    if (e && e.detail && e.detail.cart && e.detail.cart.item_count != null) { CART = e.detail.cart; paintSoon(); }
    else cartLater();
  });
  document.addEventListener('ajaxProduct:added', function () { flashAdded(); cartLater(); });

  /* ---------- state ---------- */
  var S = { open: false, added: 0, mode: '' };
  function count() { return CART ? CART.item_count || 0 : 0; }
  function total() { return CART ? CART.total_price || 0 : 0; }

  function compute() {
    var p = SV ? person() : null;
    var n = count();
    if (S.card) return { mode: 'added', p: p, n: n, card: S.card };
    if (S.added && Date.now() - S.added < 1800) return { mode: 'added', p: p, n: n };
    if (P && model) {
      var mv = masterVariant();
      var color = currentOpt(COLOR_KEY);
      var selSize = currentOpt(SIZE_KEY);
      var rec = p ? recFor(model, p) : null;
      var rs = radios(SIZE_KEY);
      var sizeChosen = rs.length ? rs.some(function (r) { return r.checked; }) : !!selSize;
      /* The theme ticks the first size on arrival. Until the shopper (or the
         size helper) touches the form, a saved size beats that default. */
      var follow = sizeChosen && (S.touched || (rec && rec.none));
      var v = follow ? (mv || variantFor(selSize, color)) : null;
      if (!v && rec && !rec.none) {
        v = variantFor(sizeValue(rec.pick.us), color);
        /* that size is out in this colour but in stock in another: offer that one */
        if ((!v || !v.a) && rec.r.best) { var alt = variantFor(sizeValue(rec.pick.us), ''); if (alt && alt.a) v = alt; }
      }
      if (!v && sizeChosen && (S.touched || rec)) v = mv || variantFor(selSize, color);
      if (n > 0 && S.showBag) return { mode: 'purchase', p: p, n: n };
      return { mode: 'product', p: p, n: n, v: v, color: v ? v.c : color, rec: rec, sizeChosen: sizeChosen, touched: !!S.touched,
               us: v ? usOf(v.s) : (rec && !rec.none ? rec.pick.us : NaN), sizeValRaw: v ? v.s : null };
    }
    /* collection page: how many models here fit, in stock */
    if (cfg.surface === 'collection' && cfg.coll && cfg.collOn && p && !(n > 0 && S.showBag)) {
      var curl = cfg.coll;
      var cat = catNow(curl);
      if (!cat) loadCat(curl, function () { paintSoon(); });
      else if (cat.length) { var cf = fitsFor(cat, p); return { mode: 'collection', p: p, n: n, cat: cat, url: curl, fits: cf, all: cat.length, us: mostUs(cf) }; }
    }
    if (n > 0) return { mode: 'purchase', p: p, n: n };
    if (p) {
      var fu = fitAcross(p);
      if (fu == null) {   /* this page has no size charts of its own: use the catalogue */
        var ac = catNow(ALL_URL);
        if (ac) fu = mostUs(fitsFor(ac, p)); else loadCat(ALL_URL, function () { paintSoon(); });
      }
      return { mode: 'fit', p: p, us: fu };
    }
    return { mode: 'unknown', p: null };
  }

  /* ---------- paint ---------- */
  var soon = 0;
  function paintSoon() { if (soon) return; soon = setTimeout(function () { soon = 0; paint(); }, 30); }

  function setCta(label, vars, href, quiet) {
    fill(ctaText, label, vars || {});
    cta.classList.toggle('is-quiet', !!quiet);
    if (href) { cta.setAttribute('href', href); cta.removeAttribute('role'); }
    else { cta.setAttribute('href', '#'); cta.setAttribute('role', 'button'); }
  }
  function paint() {
    var st = compute();
    S.mode = st.mode;
    var p = st.p, vars = { name: p ? p.name : '', who: who(p), foot: p ? trim(p.foot) : '', count: st.n || 0 };
    chip.hidden = true;
    S.noFit = false;
    mainBtn.disabled = false;
    mainBtn.setAttribute('aria-label', txt('open', 'More about your fit'));

    mainBtn.classList.toggle('no-more', st.mode !== 'fit' && st.mode !== 'collection');
    if (st.mode === 'unknown') {
      fill(kEl, txt('unknown', 'Find my size'), vars);
      subEl.textContent = '';
      setCta(txt('shop', 'Shop shoes'), vars, cfg.urls.shop);
    } else if (st.mode === 'fit') {
      vars.size = st.us != null && !isNaN(st.us) ? st.us : '';
      fill(kEl, vars.size === '' ? txt('unknown', 'Find my size') : txt('fit', 'Your fit · US [size] ✓'), vars);
      subEl.textContent = people().length > 1 ? (txt('xWho', 'Shopping for') + ' ' + p.name) : '';
      var fu = cfg.urls.fit || cfg.urls.shop;
      setCta(txt('fitBtn', 'Shop in my size'), vars, fu + (fu.indexOf('?') > -1 ? '&' : '?') + 'ks_foot=' + trim(p.foot) + '&ks_fit=' + encodeURIComponent(p.fit || 'comfort') + (p.socks ? '&ks_socks=1' : ''));
    } else if (st.mode === 'added') {
      fill(kEl, txt('added', 'Added to your bag ✓'), vars);
      subEl.textContent = st.card ? (st.n === 1 ? txt('bagOne', '1 item · [price]') : txt('bag', '[count] items · [price]')).replace(/\[count\]/g, st.n).replace(/\s*·?\s*\[price\]/g, '') : '';
      vars.priceCents = total();
      setCta(txt('checkout', 'Checkout'), vars, cfg.urls.checkout);
    } else if (st.mode === 'collection') {
      vars.count = st.fits.length; vars.all = st.all; vars.size = st.us != null ? st.us : '';
      if (st.fits.length) {
        fill(kEl, txt('cCount', '[count] of [all] styles fit [who]'), vars);
        subEl.textContent = vars.size !== '' ? strFill(txt('cSub', 'In stock · mostly US [size]'), vars) : '';
        var only = document.querySelector('input[data-kst-only]');
        if (only && !only.disabled) setCta(only.checked ? txt('cAll', 'Show all') : txt('cOnly', 'Show only these'), vars, null, only.checked);
        else setCta(txt('fitBtn', 'Shop in my size'), vars, withFoot(finderUrl(null), p) + '&ks_go=results');
      } else {
        fill(kEl, txt('cNone', 'No style here fits [who] right now'), vars);
        subEl.textContent = '';
        setCta(txt('fitsCta', 'Models that fit'), vars, withFoot(finderUrl(null), p) + '&ks_go=results', true);
      }
      if (st.n > 0 && cfg.bagChip) {
        fill(chip.querySelector('[data-kd-chip-text]') || chip, txt('bagChip', '[count]'), { count: st.n });
        chip.setAttribute('aria-label', txt('viewCart', 'View bag') + ' (' + st.n + ')');
        chip.hidden = false;
      }
    } else if (st.mode === 'purchase') {
      vars.priceCents = total();
      fill(kEl, st.n === 1 ? txt('bagOne', '1 item · [price]') : txt('bag', '[count] items · [price]'), vars);
      subEl.textContent = txt('viewCart', 'View bag');
      setCta(txt('checkout', 'Checkout'), vars, cfg.urls.checkout);
    } else { /* product */
      var rec = st.rec, v = st.v, sub = '';
      vars.size = isNaN(st.us) ? '' : st.us;
      vars.color = st.color || '';
      vars.model = model.title;
      var d = v ? delivery(v.id) : null;
      if (!p) {
        if (v) fill(kEl, txt('psel', 'US [size] · [color]'), vars);
        else fill(kEl, txt('pnofit', 'Find my size'), vars);
      } else if (rec && rec.none) {
        fill(kEl, txt('pnone', 'No match in this model'), vars);
      } else if (rec && rec.soldOut && !st.touched && (!v || !v.a)) {
        fill(kEl, txt('psold', 'US [size] · sold out in this model'), vars);
      } else if (rec && v && usOf(v.s) === rec.pick.us) {
        vars.eu = rec.pick.eu || '';
        vars.room = trim(rec.pick.room);
        vars.quality = rec.good ? txt('xFitGood', 'Excellent fit') : txt('xFitOk', 'Good fit');
        fill(kEl, rec.good ? txt('pfit', 'Your size US [size]') : txt('pclosest', 'Closest · US [size]'), vars);
        sub = txt('pfitSub', '[quality] · EU [eu]');
      } else if (v) {
        fill(kEl, txt('psel', 'US [size] · [color]'), vars);
      } else {
        fill(kEl, txt('pnofit', 'Find my size'), vars);
      }
      /* line 2: fit sentence, then the delivery estimate */
      clear(subEl);
      if (sub) {
        var tmp = el('span'); fill(tmp, sub, vars);
        /* colour the fit quality */
        var q = vars.quality || '';
        var str = tmp.textContent, at = q ? str.indexOf(q) : -1;
        if (at > -1) {
          if (at > 0) subEl.appendChild(document.createTextNode(str.slice(0, at)));
          subEl.appendChild(el('span', 'ksdock__q2', q));
          subEl.appendChild(document.createTextNode(str.slice(at + q.length)));
        } else subEl.appendChild(document.createTextNode(str));
      }
      if (d && d.text) {
        if (subEl.firstChild) subEl.appendChild(document.createTextNode(sepTxt()));
        subEl.appendChild(document.createTextNode(d.text));
      }
      mainBtn.classList.toggle('no-more', !(p && rec));
      if (st.n > 0 && cfg.bagChip) {
        fill(chip.querySelector('[data-kd-chip-text]') || chip, txt('bagChip', '[count]'), vars);
        chip.setAttribute('aria-label', txt('viewCart', 'View bag') + ' (' + (st.n || 0) + ')');
        chip.hidden = false;
      }
      var noFit = rec && !st.touched && (rec.none || (rec.soldOut && (!v || !v.a)));
      if (noFit) {
        /* say how many other models fit, and open them in the panel */
        S.noFit = true;
        var allCat = catNow(ALL_URL);
        if (!allCat) loadCat(ALL_URL, function () { paintSoon(); });
        else {
          var others = madeFor(allCat, p, P && P.handle);
          if (others) { clear(subEl); subEl.appendChild(document.createTextNode(strFill(txt('pnoneSub', '[count] other styles fit [who]'), { count: others, who: who(p), name: p.name }))); }
        }
        setCta(txt('fitsCta', 'Models that fit'), vars, null, true);
      } else if (!v) {
        setCta(st.sizeChosen && (st.touched || rec) ? txt('soldout', 'Sold out') : txt('choose', 'Choose size'), vars, null, true);
      } else if (!v.a) {
        setCta(txt('soldout', 'Sold out'), vars, null, true);
      } else {
        vars.priceCents = v.p;
        setCta(txt('add', '[price] · Add'), vars, null, false);
      }
      S.v = v;
    }
    S.st = st;
    if (st.card) { S.open = true; paintCard(st); }
    else if (!S.open || st.mode === 'purchase' || st.mode === 'unknown' || st.mode === 'added') { S.open = false; hidePanel(); }
    else paintPanel(st);
    dock.classList.toggle('is-open', S.open);
    if (S.open && shrinkReset) shrinkReset();
    mainBtn.setAttribute('aria-expanded', S.open ? 'true' : 'false');
    paintDiag(st);
  }

  /* ---------- expanded panel ---------- */
  var leaving = 0;
  function hidePanel() {
    if (panel.hidden || leaving) return;
    if (reduced()) { panel.hidden = true; return; }
    panel.classList.add('is-leaving');
    leaving = setTimeout(function () {
      leaving = 0;
      panel.classList.remove('is-leaving');
      if (!S.open) panel.hidden = true;
    }, 170);
  }
  function showPanel() {
    if (leaving) { clearTimeout(leaving); leaving = 0; panel.classList.remove('is-leaving'); }
    panel.hidden = false;
  }
  function paintPanel(st) {
    var p = st.p;
    var keep = !panel.hidden ? panel.scrollTop : 0;
    clear(panel);
    showPanel();
    var head = el('div', 'ksdock__ph');
    var hl = el('div');
    hl.appendChild(el('p', 'ksdock__title', txt('xTitle', 'Recommended for you')));
    if (p) { var b = el('p', 'ksdock__based'); fill(b, txt('xBased', 'Based on a [foot] cm foot length'), { foot: trim(p.foot), name: p.name }); hl.appendChild(b); }
    head.appendChild(hl);
    var x = el('button', 'ksdock__x', '×'); x.type = 'button'; x.setAttribute('aria-label', txt('close', 'Close'));
    x.addEventListener('click', function () { S.open = false; paint(); });
    head.appendChild(x);
    panel.appendChild(head);

    var rec = st.rec;
    if (st.mode === 'product' && rec && !rec.none) {
      var row = el('div', 'ksdock__row');
      var big = el('div', 'ksdock__big', 'US ' + rec.pick.us);
      if (rec.pick.eu) big.appendChild(el('small', null, 'EU ' + rec.pick.eu));
      row.appendChild(big);
      row.appendChild(el('span', 'ksdock__q' + (rec.good ? '' : ' is-ok'), rec.good ? txt('xFitGood', 'Excellent fit') : txt('xFitOk', 'Good fit')));
      panel.appendChild(row);
      var det = el('p', 'ksdock__detail');
      fill(det, txt('xDetail', 'Your foot [foot] cm · inside length [inner] cm · [room] cm room'), { foot: trim(p.foot), inner: trim(rec.pick.cm), room: trim(rec.pick.room) });
      panel.appendChild(det);
      var track = el('div', 'ksdock__bar2');
      var pin = el('span', 'ksdock__pin');
      var span = KS.maxRoom - KS.minRoom || 1;
      pin.style.left = Math.max(4, Math.min(96, ((rec.pick.room - KS.minRoom) / span) * 100)) + '%';
      track.appendChild(pin);
      panel.appendChild(track);
    } else if (st.mode === 'product' && rec && rec.none) {
      /* this model is not made in a size that fits: say how close it gets */
      var cl = closestIn(model, p);
      if (cl) {
        var cp = el('p', 'ksdock__detail');
        fill(cp, txt('xClosest', 'Closest in this model: US [size] · EU [eu] – [verdict]'),
          { size: cl.us, eu: cl.eu, room: trim(cl.room), verdict: cl.room < KS.minRoom ? txt('xTight', 'too tight') : txt('xLoose', 'too big') });
        panel.appendChild(cp);
      }
    } else if (st.mode === 'fit' || st.mode === 'collection') {
      var row2 = el('div', 'ksdock__row');
      row2.appendChild(el('div', 'ksdock__big', st.us != null && !isNaN(st.us) ? 'US ' + st.us : trim(p.foot) + ' cm'));
      if (st.mode === 'collection') row2.appendChild(el('span', 'ksdock__q', strFill(txt('cCount', '[count] of [all] styles fit [who]'), { count: st.fits.length, all: st.all, who: who(p), name: p.name })));
      panel.appendChild(row2);
    }

    /* other models that fit this person */
    var a2 = null;
    if (cfg.alts && p && KS) {
      if (st.mode === 'collection') paintAlts(st, st.url, '', 'picks');
      else if (st.mode === 'fit') paintAlts(st, ALL_URL, '', 'picks');
      else if (st.mode === 'product' && rec) paintAlts(st, ALL_URL, P && P.handle, (rec.none || rec.soldOut) ? 'nofit' : 'also');
    }

    var list = people();
    if (list.length > 1) {
      var whoBox = el('div', 'ksdock__who');
      whoBox.appendChild(el('span', null, txt('xWho', 'Shopping for')));
      list.forEach(function (q) {
        var bt = el('button', null, q.name); bt.type = 'button';
        bt.setAttribute('aria-pressed', p && q.id === p.id ? 'true' : 'false');
        bt.addEventListener('click', function () {
          SV.pick(q.id);
          applyRec(q);
          paint();
          if (KS.track) KS.track('ks_dock_person', { surface: cfg.surface });
        });
        whoBox.appendChild(bt);
      });
      panel.appendChild(whoBox);
    }

    var links = el('div', 'ksdock__links');
    /* Change fit = edit this person's foot length / fit in My sizes; the finder is the fallback */
    var a1 = el('a', null, txt('xChange', 'Change fit')); a1.href = finderUrl(p);
    a1.addEventListener('click', function (e) {
      if (window.KSMySizes && typeof window.KSMySizes.open === 'function') {
        e.preventDefault();
        S.open = false; paint();
        window.KSMySizes.open();
      }
    });
    links.appendChild(a1);
    panel.scrollTop = keep;
    if (st.mode === 'product' && !(cfg.alts && p && KS)) { a2 = el('a', null, txt('xModels', 'See better-fitting models')); a2.href = finderUrl(p) + (p && p.foot >= 10 ? '&ks_go=results' : ''); links.appendChild(a2); }
    panel.appendChild(links);
  }

  /* a row of up to N small cards; tapping one opens that model with the
     size already picked (the size helper reads ks_foot / ks_fit) */
  function paintAlts(st, url, skip, kind) {
    var p = st.p;
    var wrap = el('div', 'ksdock__alts');
    var head = el('p', 'ksdock__alth');
    var ht = el('span', null, '');
    head.appendChild(ht);
    var row = el('div', 'ksdock__altrow');
    wrap.appendChild(head);
    wrap.appendChild(row);
    wrap.hidden = true;
    /* goes above the person switch and the links */
    panel.appendChild(wrap);
    loadCat(url, function (cat) {
      if (!wrap.isConnected) return;
      var list = fitsFor(cat, p, skip);
      if (kind === 'also' && st.rec && st.rec.pick) {
        var mine = st.rec.pick.score;
        list = list.filter(function (a) { return a.pick.score >= mine; });
      }
      /* on a product page the same range first: heel wheel shoes for a heel
         wheel model, roller skate shoes for a roller skate model */
      if (skip) {
        var fam = '';
        for (var ci = 0; ci < cat.length; ci++) if (cat[ci].r.h === skip) { fam = cat[ci].r.f || ''; break; }
        if (fam) list.sort(function (a, b) { return ((a.x.r.f === fam) ? 0 : 1) - ((b.x.r.f === fam) ? 0 : 1) || b.pick.score - a.pick.score || a.x.i - b.x.i; });
      }
      if (!list.length) { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); return; }
      var vars = { who: who(p), name: p.name, count: list.length, all: madeFor(cat, p, '') };
      fill(ht, kind === 'nofit' ? txt('xAltsNo', 'These fit [who]') : kind === 'picks' ? txt('xPicks', 'Top picks for [who]') : txt('xAlts', 'Also a great fit for [who]'), vars);
      var n = Math.max(2, Math.min(6, cfg.altsN || 3));
      if (list.length > n || kind !== 'picks') {
        var all = el('a', null, strFill(txt('xAll', 'See all [count]'), { who: vars.who, name: vars.name, count: vars.all || list.length }));
        all.href = withFoot(finderUrl(null), p) + '&ks_go=results';
        head.appendChild(all);
      }
      list.slice(0, n).forEach(function (a) { row.appendChild(altCard(a, p)); });
      wrap.hidden = false;
      refreshMoney();
    });
  }
  function altCard(a, p) {
    var r = a.x.r;
    var card = el('a', 'ksdock__alt' + (a.good ? ' is-good' : ''));
    card.href = withFoot(r.u, p);
    if (r.i) { var im = el('img', 'ksdock__altimg'); im.alt = ''; im.loading = 'lazy'; im.decoding = 'async'; im.src = r.i; card.appendChild(im); }
    card.appendChild(el('span', 'ksdock__altt', shortTitle(r.t)));
    card.appendChild(el('span', 'ksdock__altm', 'US ' + a.pick.us));
    if (a.pick.eu) card.setAttribute('aria-label', shortTitle(r.t) + ', US ' + a.pick.us + ', EU ' + a.pick.eu);
    if (r.p != null) { var pr = el('span', 'ksdock__altp'); pr.appendChild(el('span', 'money', money(r.p))); card.appendChild(pr); }
    card.addEventListener('click', function () { if (KS && KS.track) KS.track('ks_dock_alt', { surface: cfg.surface, size: a.pick.us, model: r.t }); });
    return card;
  }

  /* ---------- added-to-bag card ---------- */
  function paintCard(st) {
    var c = st.card, v = c.v;
    clear(panel);
    showPanel();
    var head = el('div', 'ksdock__ph');
    head.appendChild(el('p', 'ksdock__title', txt('added', 'Added to your bag ✓')));
    var x = el('button', 'ksdock__x', '×'); x.type = 'button'; x.setAttribute('aria-label', txt('close', 'Close'));
    x.addEventListener('click', closeCard);
    head.appendChild(x);
    panel.appendChild(head);

    var card = el('div', 'ksdock__card');
    var src = (c.item && c.item.image) || (P && P.img) || '';
    /* the cart API gives the full-size image; ask the CDN for a small one */
    if (src && /\/cdn\/|cdn\.shopify\.com|\/s\/files\//.test(src) && !/[?&]width=/.test(src)) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
    if (src) { var im = el('img', 'ksdock__thumb'); im.alt = ''; im.loading = 'lazy'; im.src = src; card.appendChild(im); }
    var body = el('div', 'ksdock__cbody');
    body.appendChild(el('p', 'ksdock__ctitle', (c.item && c.item.product_title) || (model && model.title) || ''));
    var meta = el('p', 'ksdock__cmeta');
    var bits = [];
    if (v && v.s) bits.push('US ' + usOf(v.s));
    if (v && v.c) bits.push(v.c);
    var tpl = bits.join(' · ') + (bits.length ? ' · ' : '') + '[price]';
    fill(meta, tpl, { priceCents: c.item ? c.item.final_price : (v ? v.p : 0) });
    body.appendChild(meta);
    var d = v ? delivery(v.id) : null;
    if (d && d.text) body.appendChild(el('p', 'ksdock__cmeta', d.text));
    card.appendChild(body);
    panel.appendChild(card);

    var btns = el('div', 'ksdock__cbtns');
    var keep = el('a', 'ksdock__cta is-quiet', txt('keep', 'Keep shopping')); keep.href = '#'; keep.setAttribute('role', 'button');
    keep.addEventListener('click', function (e) { e.preventDefault(); closeCard(); });
    btns.appendChild(keep);
    var bag = el('a', 'ksdock__cta is-quiet', txt('viewCart', 'View bag')); bag.href = cfg.urls.cart || '/cart';
    bag.addEventListener('click', function (e) { e.preventDefault(); closeCard(); openCart(); });
    btns.appendChild(bag);
    panel.appendChild(btns);
    refreshMoney();
  }
  function closeCard() {
    S.card = null;
    S.open = false;
    S.showBag = false;
    paint();
  }
  /* add through the cart API ourselves (no theme drawer), then tell the theme */
  function addDirect(v) {
    cta.classList.add('is-busy');
    fetch((cfg.urls.cart || '/cart') + '/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: v.id, quantity: 1 })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        cta.classList.remove('is-busy');
        if (!res.ok) { addFailed(); return; }
        loadCart(function (c) {
          /* the theme rebuilds its drawer and header count from these */
          try {
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c } }));
          } catch (e) {}
        });
        S.added = 0;
        S.card = { v: v, item: res.j };
        paint();
        if (KS && KS.track) KS.track('ks_dock_add', { surface: cfg.surface, mode: 'card' });
      })
      .catch(function () { cta.classList.remove('is-busy'); addFailed(); });
  }
  var errT = 0;
  function addFailed() {
    clear(subEl);
    subEl.appendChild(el('span', 'ksdock__err', txt('addErr', "Couldn't add this one – please try again")));
    clearTimeout(errT);
    errT = setTimeout(paintSoon, 3500);
  }

  /* pick the recommended size in the theme's own buttons */
  function applyRec(p) {
    if (!model || !p) return false;
    var x = recFor(model, p);
    if (!x || x.none || x.soldOut) return false;
    return choose(SIZE_KEY, sizeValue(x.pick.us));
  }

  /* ---------- actions ---------- */
  function themeAddButton() {
    return form && (form.querySelector('[data-add-to-cart]') || form.querySelector('button[type=submit][name=add]') || form.querySelector('[type=submit]'));
  }
  function scrollToSizes() {
    var r = radios(SIZE_KEY)[0] || (secRoot && secRoot.querySelector('select[data-index="' + SIZE_KEY + '"]'));
    var wrap = r ? (r.closest('.variant-wrapper') || r.closest('fieldset') || r.parentNode) : null;
    if (wrap) wrap.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
  }
  var pendingAdd = 0;
  function flashAdded() {
    S.added = Date.now();
    cta.classList.remove('is-busy');
    paint();
    setTimeout(function () {
      S.added = 0;
      /* "mini": stay on the bag until the shopper touches the product form again */
      S.showBag = cfg.afterAdd === 'mini';
      paint();
    }, 1800);
    if (KS && KS.track) KS.track('ks_dock_add', { surface: cfg.surface });
  }
  cta.addEventListener('click', function (e) {
    var st = S.st || {};
    if (st.mode === 'collection' && cta.getAttribute('href') === '#') {
      e.preventDefault();
      var only = document.querySelector('input[data-kst-only]');
      if (only && !only.disabled) {
        only.click();
        /* to the products, under the sticky header; the filter re-draws the
           grid, which can stop a smooth scroll – so check and finish it */
        var toGrid = function (smooth) {
          var grid = document.getElementById('CollectionAjaxResult') || document.querySelector('.grid-product');
          if (!grid) return -1;
          var hdr = document.querySelector('.site-header, #SiteHeader');
          var off = hdr ? Math.min(140, hdr.getBoundingClientRect().height) + 12 : 90;
          var top = Math.max(0, Math.round(grid.getBoundingClientRect().top + window.pageYOffset - off));
          window.scrollTo({ top: top, behavior: smooth && !reduced() ? 'smooth' : 'auto' });
          return top;
        };
        setTimeout(function () {
          var want = toGrid(true);
          setTimeout(function () { if (want > -1 && Math.abs(window.pageYOffset - want) > 120) toGrid(false); }, 900);
        }, 200);
        setTimeout(paintSoon, 120);
        if (KS && KS.track) KS.track('ks_dock_only', { surface: cfg.surface, on: only.checked });
      }
      return;
    }
    if (st.mode === 'product' && S.noFit && cta.getAttribute('href') === '#') {
      e.preventDefault();
      S.open = true;
      paint();
      if (KS && KS.track) KS.track('ks_dock_open', { surface: cfg.surface, mode: 'nofit' });
      return;
    }
    if (st.mode !== 'product' && st.mode !== 'added') return; /* plain link */
    if (st.mode === 'product' && cta.getAttribute('href') !== '#') return; /* a real link (better-fitting models) */
    e.preventDefault();
    if (st.mode === 'added') { location.href = cfg.urls.checkout; return; }
    var v = S.v;
    if (!v) { scrollToSizes(); return; }
    if (!v.a) return;
    /* keep the theme's form in step with what we add */
    var ok = true;
    if (v.s) ok = choose(SIZE_KEY, v.s) || ok;
    if (COLOR_KEY && v.c) choose(COLOR_KEY, v.c);
    if (cfg.afterAdd === 'card') { addDirect(v); return; }
    var btn = themeAddButton();
    var inp = form && form.querySelector('[name="id"]');
    if (!btn || !inp) { scrollToSizes(); return; }
    cta.classList.add('is-busy');
    clearTimeout(pendingAdd);
    var tries = 0;
    (function go() {
      if (String(inp.value) !== String(v.id) && tries < 12) { tries++; pendingAdd = setTimeout(go, 80); return; }
      if (String(inp.value) !== String(v.id)) inp.value = v.id;
      btn.click();
      /* if the theme does not use ajax, the page reloads; if it does, we hear ajaxProduct:added */
      pendingAdd = setTimeout(function () { cta.classList.remove('is-busy'); }, 4000);
    })();
  });
  mainBtn.addEventListener('click', function () {
    var st = S.st || {};
    if (st.mode === 'unknown') { location.href = finderUrl(null); return; }
    if (st.mode === 'added') { location.href = cfg.urls.checkout; return; }
    if (st.mode === 'purchase') {
      openCart(); return;
    }
    if (st.mode === 'product' && !st.p && !st.rec) { location.href = finderUrl(null); return; }
    S.open = !S.open;
    paint();
    if (S.open && KS && KS.track) KS.track('ks_dock_open', { surface: cfg.surface, mode: st.mode });
  });
  /* The bag: the theme's slide-out cart drawer, like the header icon.
     The drawer fills itself over the network first, so give it a moment;
     if it still is not open, the cart page is the fallback. */
  function openCart() {
    var cartUrl = cfg.urls.cart || '/cart';
    if (cfg.surface === 'cart') { window.scrollTo({ top: 0, behavior: reduced() ? 'auto' : 'smooth' }); return; }
    var opener = document.querySelector('.js-drawer-open-cart');
    if (!opener) { location.href = cartUrl; return; }
    /* after the tap on the dock has finished bubbling: the drawer closes
       itself on any click outside, and the tap that opened it would count */
    setTimeout(function () {
      try { opener.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true })); } catch (e) { location.href = cartUrl; return; }
      var waited = 0;
      (function check() {
        if (html.classList.contains('js-drawer-open')) return;
        waited += 100;
        if (waited >= 1500) { location.href = cartUrl; return; }
        setTimeout(check, 100);
      })();
    }, 30);
    if (KS && KS.track) KS.track('ks_dock_bag', { surface: cfg.surface });
  }
  chip.addEventListener('click', openCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && S.open) { if (S.card) closeCard(); else { S.open = false; paint(); } } });

  /* Drag on phones: pull the dock up to open the panel, pull the panel
     down to close it. The bar follows the finger a little (rubber band);
     let go past the point and it opens/closes with a spring, otherwise it
     springs back. A quick flick counts too. */
  if (cfg.swipe) {
    var g = null;
    var canOpen = function () {
      var st = S.st || {};
      return !S.card && ((st.mode === 'product' && st.p && st.rec) || st.mode === 'fit' || st.mode === 'collection');
    };
    dock.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { g = null; return; }
      g = { y: e.touches[0].clientY, x: e.touches[0].clientX, t: Date.now(), open: S.open, inPanel: panel.contains(e.target), drag: '', dy: 0 };
    }, { passive: true });
    dock.addEventListener('touchmove', function (e) {
      if (!g) return;
      var dy = e.touches[0].clientY - g.y, dx = e.touches[0].clientX - g.x;
      if (!g.drag) {
        if (Math.abs(dy) < 8) return;
        if (Math.abs(dx) > Math.abs(dy)) { g = null; return; }   /* sideways: e.g. the model cards */
        if (!g.open && dy < 0 && canOpen()) g.drag = 'up';
        else if (g.open && dy > 0 && (!g.inPanel || panel.scrollTop <= 0)) g.drag = 'down';
        else { g = null; return; }
        dock.classList.add('is-dragging');
      }
      if (e.cancelable) e.preventDefault();
      g.dy = dy;
      if (g.drag === 'up') bar.style.transform = 'translateY(' + Math.max(-30, dy * 0.32) + 'px)';
      else panel.style.transform = 'translateY(' + Math.max(0, dy) + 'px)';
    }, { passive: false });
    var release = function () {
      if (!g) return;
      var d = g; g = null;
      dock.classList.remove('is-dragging');
      bar.style.transform = '';
      panel.style.transform = '';
      if (!d.drag) return;
      var quick = Date.now() - d.t < 260;
      if (d.drag === 'up' && (d.dy < -34 || (quick && d.dy < -14))) {
        S.open = true; paint();
        if (KS && KS.track) KS.track('ks_dock_open', { surface: cfg.surface, mode: 'drag' });
      } else if (d.drag === 'down' && (d.dy > 70 || (quick && d.dy > 24))) {
        if (S.card) closeCard(); else { S.open = false; paint(); }
      }
    };
    dock.addEventListener('touchend', release, { passive: true });
    dock.addEventListener('touchcancel', release, { passive: true });
  }

  /* ---------- hide while a drawer / modal / size chart / cookie bar is open ---------- */
  var html = document.documentElement;
  /* the Tidio chat window is open (API event, or a look at its widget) */
  var chatWindowOpen = false;
  function tidioWindowOpen() {
    if (chatWindowOpen) return true;
    var tc = document.getElementById('tidio-chat');
    var sr = tc && tc.shadowRoot;
    if (!sr || !shown(tc)) return false;
    var chat = sr.querySelector('.chat');
    return !!chat && !chat.classList.contains('chat-closed') && !sr.querySelector('.chat-closed') && chat.getBoundingClientRect().height > 200;
  }
  /* Anything that opens over the page: the theme's drawers and modals
     (js-drawer-open, modal-open, lock-scroll, photo zoom), predictive
     search, our size chart (kssc-lock), My sizes (kms-lock), the cookie
     bar, Tidio – and, as a catch-all, anything that locks page scroll. */
  var LOCK_HTML = ['js-drawer-open', 'modal-open', 'lock-scroll', 'pswp-open-in-ios', 'kssc-lock', 'kms-lock', 'kst-cookie-open', 'jdgm-modal-opened'];
  var LOCK_BODY = ['predictive-overflow-hidden', 'modal-open', 'jdgm-modal-opened', 'pc-popup-open'];
  /* offsetParent is null for position:fixed elements, so measure instead */
  function shown(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function blocked() {
    if (tidioWindowOpen()) return true;
    for (var i = 0; i < LOCK_HTML.length; i++) if (html.classList.contains(LOCK_HTML[i])) return true;
    for (var j = 0; j < LOCK_BODY.length; j++) if (document.body.classList.contains(LOCK_BODY[j])) return true;
    var ov = getComputedStyle(document.body).overflow, ovh = getComputedStyle(html).overflow;
    if (ov === 'hidden' || ovh === 'hidden') return true;
    if (shown(document.getElementById('shopify-pc__banner'))) return true;
    var ms = document.querySelectorAll('.modal.modal--is-active, .modal--is-active, .pswp--open:not([aria-hidden="true"]), .kms, dialog[open]');
    for (var k = 0; k < ms.length; k++) if (shown(ms[k])) return true;
    var ae = document.activeElement;
    if (isPhone.matches && ae && /^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName) && ae.type !== 'radio' && ae.type !== 'checkbox' && !dock.contains(ae)) return true;
    return false;
  }
  function visibility() { dock.classList.toggle('is-away', blocked()); }
  new MutationObserver(visibility).observe(html, { attributes: true, attributeFilter: ['class', 'style'] });
  new MutationObserver(visibility).observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
  document.addEventListener('focusin', visibility);
  document.addEventListener('focusout', function () { setTimeout(visibility, 50); });
  setInterval(visibility, 800);

  /* ---------- shrink on scroll ----------
     Scroll-linked, like a phone browser's toolbar: every pixel scrolled
     down shrinks the dock a little (fully after 120 px), every pixel up
     grows it back. The size is written once per frame (requestAnimationFrame)
     on its own CSS property (scale), so it never fights the hide/show
     slide. Bounces past the top or bottom of the page are ignored. When
     the scrolling stops it settles with a short spring:
       "Scrolling up or scrolling stops" -> back to full size
       "Scrolling up"                    -> to the nearer end            */
  var shrinkReset = null;
  if (cfg.shrink && cfg.shrink.on && !reduced()) {
    var minS = Math.max(0.4, Math.min(1, (cfg.shrink.to || 70) / 100));
    var after = Math.max(0, cfg.shrink.after || 80), RANGE = 120;
    var sp = 0, lastY = Math.max(0, window.pageYOffset), raf = 0, settleT = 0;
    var drawScale = function () { raf = 0; dock.style.setProperty('--kd-scale', (1 - sp * (1 - minS)).toFixed(3)); };
    var draw = function () { if (!raf) raf = window.requestAnimationFrame(drawScale); };
    shrinkReset = function () { if (sp) { sp = 0; dock.classList.remove('is-scrolling'); draw(); } };
    window.addEventListener('scroll', function () {
      var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      var y = Math.min(Math.max(window.pageYOffset, 0), max);
      var dy = y - lastY;
      lastY = y;
      if (S.open || S.card || dock.classList.contains('is-dragging')) sp = 0;
      else {
        sp = Math.min(1, Math.max(0, sp + dy / RANGE));
        /* near the top it is always (almost) full size */
        if (y < after) sp = Math.min(sp, after > 0 ? y / after : 0);
      }
      dock.classList.add('is-scrolling');
      draw();
      clearTimeout(settleT);
      settleT = setTimeout(function () {
        dock.classList.remove('is-scrolling');
        if (cfg.shrink.back === 'stop' || S.open) sp = 0;
        else sp = sp > 0.5 ? 1 : 0;
        draw();
      }, cfg.shrink.back === 'stop' ? 650 : 160);
    }, { passive: true });
  }

  /* ---------- keep the end of the page clear of the dock ----------
     A spacer as tall as the dock at the very end of the page, so the
     footer's last lines (payment icons, copyright) can be scrolled above it. */
  Array.prototype.forEach.call(document.querySelectorAll('.ksdock-spacer'), function (n) { n.parentNode.removeChild(n); });
  var spacer = document.createElement('div');
  spacer.className = 'ksdock-spacer';
  spacer.setAttribute('aria-hidden', 'true');
  dock.parentNode.insertBefore(spacer, dock);
  function fitSpacer() {
    var shown = !dock.hidden && window.getComputedStyle(dock).display !== 'none';
    var h = shown ? Math.ceil(bar.getBoundingClientRect().height / (parseFloat(dock.style.getPropertyValue('--kd-scale')) || 1)) + ((cfg.look && cfg.look.offset) || 12) + 12 : 0;
    spacer.style.height = h + 'px';
  }
  if (window.ResizeObserver) { try { new ResizeObserver(fitSpacer).observe(bar); } catch (e) {} }
  window.addEventListener('resize', fitSpacer);

  /* ---------- chat (Tidio) ---------- */
  /* Tidio's widget lives in #tidio-chat (shadow DOM). hide()/show()/open()
     are its public API; the CSS rule is the belt to that braces. */
  var chatStyle = null, chatOn = !!(cfg.chat && cfg.chat.on), chatDots = [];
  function api() { return window.tidioChatApi || null; }
  function tidioHide(on) {
    if (!chatOn || !cfg.chat.hideTidio) return;
    if (!chatStyle) {
      chatStyle = document.createElement('style');
      chatStyle.id = 'ks-dock-tidio';
      chatStyle.textContent = '#tidio-chat{display:none !important}';
    }
    if (on && !chatStyle.parentNode) document.head.appendChild(chatStyle);
    if (!on && chatStyle.parentNode) chatStyle.parentNode.removeChild(chatStyle);
    var a = api();
    try { if (a) { if (on) a.hide(); else a.show(); } } catch (e) {}
  }
  function setDots(show) { chatDots.forEach(function (d) { d.hidden = !show; }); }
  function openChat() {
    var a = api();
    tidioHide(false);
    if (a && typeof a.open === 'function') { try { a.open(); } catch (e) {} setDots(false); }
    else {
      /* not loaded yet (slow network, consent): open as soon as it is */
      document.addEventListener('tidioChat-ready', function once() {
        document.removeEventListener('tidioChat-ready', once);
        var b = api(); if (b) { try { b.show(); b.open(); } catch (e) {} }
      });
    }
    if (KS && KS.track) KS.track('ks_dock_chat', { surface: cfg.surface });
  }
  function wireTidio() {
    var a = api(); if (!a || wireTidio.done) return; wireTidio.done = true;
    try {
      a.on('open', function () { chatWindowOpen = true; visibility(); tidioHide(false); setDots(false); });
      a.on('close', function () { chatWindowOpen = false; tidioHide(true); visibility(); });
      a.on('messageFromOperator', function () { setDots(true); });
    } catch (e) {}
    tidioHide(true);
  }
  document.addEventListener('tidioChat-ready', wireTidio);
  wireTidio();
  if (chatOn) {
    tidioHide(true);
    /* pos 'none': no button anywhere, chat opens only from #chat links */
    if (cfg.chat.pos === 'dock-left' || cfg.chat.pos === 'dock-right') {
      chatBtn.hidden = false;
      chatDots.push(chatDot);
      bar.classList.add(cfg.chat.pos === 'dock-right' ? 'has-chat-right' : 'has-chat-left');
      chatBtn.addEventListener('click', openChat);
    }
    /* any link to #chat on the page opens the chat too (menu, footer, pages) */
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href="#chat"], a[href$="#chat"]') : null;
      if (!a) return;
      e.preventDefault();
      openChat();
    });
  }

  /* ---------- bubbles beside / above the dock ---------- */
  var icons = dock.querySelector('template[data-kd-icons]');
  function icon(name) {
    var src = icons && icons.content ? icons.content.querySelector('[data-icon="' + name + '"]') : null;
    return src ? src.cloneNode(true) : null;
  }
  var topBubbles = [];
  function bubble(kind) {
    if (kind === 'chat' && !(chatOn && cfg.chat.pos === 'bubble')) return null;
    if (kind === 'sizes' && !SV) return null;
    var b = el('button', 'ksdock__bubble ksdock__bubble--' + kind);
    b.type = 'button';
    var ic = icon(kind); if (ic) b.appendChild(ic);
    if (kind === 'chat') {
      b.setAttribute('aria-label', txt('chat', 'Chat with us'));
      var dot = el('span', 'ksdock__dot'); dot.hidden = true; b.appendChild(dot); chatDots.push(dot);
      b.addEventListener('click', openChat);
    } else if (kind === 'sizes') {
      b.setAttribute('aria-label', txt('sizes', 'My sizes'));
      b.addEventListener('click', function () {
        if (window.KSMySizes && typeof window.KSMySizes.open === 'function') window.KSMySizes.open();
        else location.href = finderUrl(SV ? person() : null);
        if (KS && KS.track) KS.track('ks_dock_sizes', { surface: cfg.surface });
      });
    } else if (kind === 'top') {
      b.setAttribute('aria-label', txt('top', 'Back to top'));
      b.classList.add('is-off');
      topBubbles.push(b);
      b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduced() ? 'auto' : 'smooth' }); });
    } else return null;
    return b;
  }
  ['left', 'right'].forEach(function (side) {
    var slot = dock.querySelector('[data-kd-slot="' + side + '"]');
    var kind = cfg.slots ? cfg.slots[side] : 'none';
    var b = slot && kind && kind !== 'none' ? bubble(kind) : null;
    if (b) { slot.appendChild(b); slot.hidden = false; dock.classList.add('has-slot-' + side); }
  });
  if (cfg.slots && cfg.slots.above) dock.classList.add('ksdock--slots-above');
  if (topBubbles.length) {
    var topAfter = (cfg.slots && cfg.slots.topAfter) || 600;
    var topTick = function () { var on = window.pageYOffset > topAfter; topBubbles.forEach(function (b) { b.classList.toggle('is-off', !on); }); };
    window.addEventListener('scroll', topTick, { passive: true });
    topTick();
  }

  /* ---------- diagnostics (theme editor only; the element exists only there) ---------- */
  function paintDiag(st) {
    if (!diag) return;
    var p = st.p;
    diag.textContent = 'KS Dock · ' + st.mode + ' · ' + cfg.surface +
      (p ? ' · person ' + p.name + ' ' + trim(p.foot) + ' cm/' + p.fit : ' · no saved size') +
      (model ? ' · chart ' + model.chart : (P ? ' · product: no chart match' : '')) +
      (st.v ? ' · variant ' + st.v.id : '') +
      ' · bag ' + count() +
      (st.mode === 'collection' ? ' · fits ' + st.fits.length + '/' + st.all : '') +
      (KS ? '' : ' · KSFinder missing') + (SV ? '' : ' · saved sizes off') +
      (cfg.delivery && !window.KSDelivery && P ? ' · no delivery data' : '');
  }

  /* ---------- wiring ---------- */
  if (secRoot) {
    secRoot.addEventListener('variantChange', paintSoon);
    secRoot.addEventListener('change', function (e) {
      if (e.target && /^(INPUT|SELECT)$/.test(e.target.tagName)) S.touched = true;
      S.showBag = false;
      S.card = null;
      paintSoon();
    });
  }
  document.addEventListener('ks:sizes', paintSoon);
  /* the "Shop in the size of" bar on collections: the dock follows its person */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-kst-person]') : null;
    if (!b) { if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-kst-only')) setTimeout(paintSoon, 80); return; }
    var id = b.getAttribute('data-kst-person');
    if (id && SV && SV.get(id)) SV.pick(id);
    setTimeout(paintSoon, 80);
  });
  window.addEventListener('pageshow', function () { loadCart(); });
  document.addEventListener('shopify:section:load', paintSoon);

  /* ?ks_go=results links are handled by the size finder section itself */

  dock.hidden = false;
  paint();
  fitSpacer();
  visibility();
  loadCart();
  /* the product form and delivery script may finish after us */
  setTimeout(paintSoon, 400);
  setTimeout(paintSoon, 1500);
})();
